/**
 * pdp-auto-related.js
 * Fetches recommendations from Shopify's native API, builds par-card cards,
 * initialises Swiper carousel. Variant modal + AJAX ATC.
 */
(function () {
  'use strict';

  /* ── Money formatter ── */
  function formatMoney(cents) {
    try {
      const code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
        style: 'currency', currency: code, currencyDisplay: 'symbol',
        minimumFractionDigits: 0, maximumFractionDigits: 2
      }).format(cents / 100);
    } catch { return '₹' + (cents / 100).toFixed(0); }
  }

  /* ── Weight detection for price-card layout ── */
  function parseUnit(label) {
    const m = String(label).match(/([\d.]+)\s*(kg|g|l|ml|lb)\b/i);
    if (!m) return null;
    let v = parseFloat(m[1]);
    const u = m[2].toLowerCase();
    if (u === 'kg') { v *= 1000; return { value: v, unit: 'g' }; }
    if (u === 'l')  { v *= 1000; return { value: v, unit: 'ml' }; }
    if (u === 'lb') return null;
    return { value: v, unit: u };
  }
  function isWeightOption(values) {
    let h = 0;
    values.forEach(function (v) { if (parseUnit(v)) h++; });
    return h >= Math.ceil(values.length / 2);
  }

  /* ── Cart helpers ── */
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  async function cartAdd(variantId) {
    const res = await fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });
    const data = await res.json();
    if (!res.ok) throw data;
    return data;
  }

  async function refreshCart(countEl) {
    try {
      const res  = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      if (countEl) countEl.textContent = cart.item_count;
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
      return cart;
    } catch { return null; }
  }


  /* ── Build card HTML ── */
  function buildCardHTML(product) {
    const cv = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    const img = (product.images && product.images[0])
      ? product.images[0]
      : 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300"%3E%3Crect fill="%23f0f0f0" width="300" height="300"/%3E%3C/svg%3E';
    const hasVariants = product.variants.length > 1 && cv.title !== 'Default Title';
    const hasDiscount = cv.compare_at_price && cv.compare_at_price > cv.price;
    const rating      = (product.metafields && product.metafields.reviews && product.metafields.reviews.rating) || '4.5';
    const ratingCount = (product.metafields && product.metafields.reviews && product.metafields.reviews.rating_count) || '1k+';
    const discountPct = hasDiscount ? Math.round((cv.compare_at_price - cv.price) / cv.compare_at_price * 100) : 0;
    const safeTitle   = product.title.replace(/"/g, '&quot;');

    return `
<div class="par-card" data-rp-card
     data-product-handle="${product.handle}"
     data-product-url="${product.url}"
     data-variant-id="${cv.id}"
     data-available="${cv.available}"
     data-variant-count="${product.variants.length}">
  <div class="par-card__img-wrap">
    <a href="${product.url}" tabindex="-1" aria-hidden="true">
      <img src="${img}" alt="${safeTitle}" width="300" height="300" loading="lazy" decoding="async">
    </a>
    <button class="par-atc-btn" data-rp-atc aria-label="Add ${safeTitle} to cart">
      <span class="par-atc-icon">
        <svg width="13" height="13" viewBox="0 0 12 12" fill="none" aria-hidden="true">
          <path d="M6 1.5v9M1.5 6h9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </span>
      <span class="par-atc-spinner" hidden aria-hidden="true">
        <svg viewBox="0 0 24 24" width="14" height="14">
          <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-dasharray="40 100"/>
        </svg>
      </span>
      <span class="par-atc-check" hidden aria-hidden="true">
        <svg width="14" height="11" viewBox="0 0 14 11" fill="none">
          <path d="M1 5.5L5 9.5L13 1.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </button>
  </div>
  <div class="par-card__body">
    <div class="par-card__meta">
      <!-- <span class="par-rating" aria-label="Rating">
        <svg width="11" height="11" viewBox="0 0 10 10" fill="none" aria-hidden="true">
          <path d="M4.22 1.19c.1-.21.39-.21.5 0l1.01 2.15c.04.09.12.14.21.15l2.27.35c.22.03.31.32.15.49L6.72 6.01c-.07.07-.1.17-.08.26l.39 2.37c.04.23-.2.41-.4.3L4.6 7.82a.28.28 0 0 0-.26 0L2.31 8.94c-.2.11-.44-.08-.4-.31l.39-2.37a.28.28 0 0 0-.08-.26L.58 4.33C.42 4.17.51 3.88.74 3.85l2.27-.35a.28.28 0 0 0 .21-.15L4.22 1.19Z" fill="#cd2028"/>
        </svg>
        <span class="par-rating__val">${rating}</span>
        <span class="par-rating__count">(${ratingCount})</span>
      </span> -->
    </div>
    <h3 class="par-card__title"><a href="${product.url}">${product.title}</a></h3>
    ${hasVariants ? `
    <div class="par-card__variant" data-rp-variant-selector role="button" tabindex="0" aria-label="Select options for ${safeTitle}">
      <span class="par-variant__text">${cv.title}</span>
      <svg width="7" height="5" viewBox="0 0 7 5" fill="none" aria-hidden="true">
        <path d="M3.09 4.05c.11.11.28.11.39 0L6.31 1.23C6.49 1.05 6.36.75 6.11.75H.47C.22.75.09 1.05.27 1.23L3.09 4.05Z" fill="#3C4886"/>
      </svg>
    </div>` : ''}
  </div>
  <div class="par-card__footer">
    <span class="par-price">${formatMoney(cv.price)}</span>
    ${hasDiscount ? `<span class="par-compare"><s>${formatMoney(cv.compare_at_price)}</s></span>` : ''}
    ${hasDiscount ? `<span class="par-discount-badge">${discountPct}% off</span>` : ''}
  </div>
</div>`;
  }


  /* ── ATC button state ── */
  function setAtcState(btn, state) {
    const icon    = btn.querySelector('.par-atc-icon');
    const spinner = btn.querySelector('.par-atc-spinner');
    const check   = btn.querySelector('.par-atc-check');
    btn.classList.remove('is-loading', 'is-success', 'is-error');
    if (icon)    icon.hidden    = true;
    if (spinner) spinner.hidden = true;
    if (check)   check.hidden   = true;
    if (state === 'loading')  { btn.classList.add('is-loading');  if (spinner) spinner.hidden = false; }
    else if (state === 'success') { btn.classList.add('is-success'); if (check) check.hidden = false; }
    else if (state === 'error')   { btn.classList.add('is-error');   if (icon)  icon.hidden  = false; }
    else { if (icon) icon.hidden = false; }
  }

  /* ── Toast ── */
  function showToast(toastEl, msg, isError) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.toggle('par-toast--error', Boolean(isError));
    toastEl.classList.add('par-toast--show');
    clearTimeout(toastEl._timer);
    toastEl._timer = setTimeout(function () { toastEl.classList.remove('par-toast--show'); }, 2400);
  }

  /* ── Product cache ── */
  const productCache = new Map();

  async function fetchProductData(card) {
    const handle = card.dataset.productHandle;
    if (!handle) throw new Error('Missing product handle');
    if (productCache.has(handle)) return productCache.get(handle);

    // Always use /products/{handle}.js — not productUrl which may be collection-scoped
    const res = await fetch(ROOT + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Product fetch failed ' + res.status);
    const raw = await res.json();

    // Normalise option names — endpoint may return strings or objects
    const optionNames = Array.isArray(raw.options)
      ? raw.options.map(function (o) { return typeof o === 'string' ? o : (o.name || String(o)); })
      : [];

    const optionsWithValues = optionNames.map(function (name, idx) {
      const seen = new Set();
      raw.variants.forEach(function (v) {
        const val = Array.isArray(v.options) && v.options[idx] != null
          ? v.options[idx]
          : v['option' + (idx + 1)];
        if (val != null) seen.add(String(val));
      });
      return { name: name, values: Array.from(seen) };
    });

    const product = {
      title: raw.title,
      url: '/products/' + raw.handle,
      handle: raw.handle,
      options: optionNames,
      optionsWithValues: optionsWithValues,
      variants: raw.variants.map(function (v) {
        const opts = Array.isArray(v.options) && v.options.length
          ? v.options.map(function (o) { return String(o); })
          : [v.option1, v.option2, v.option3].filter(function (o) { return o != null; }).map(String);
        return {
          id: v.id, title: v.title, options: opts,
          available: v.available, price: v.price,
          compare_at_price: v.compare_at_price,
          price_formatted: formatMoney(v.price),
          compare_at_price_fmt: v.compare_at_price ? formatMoney(v.compare_at_price) : null
        };
      })
    };
    productCache.set(handle, product);
    return product;
  }

  function findVariant(product, selected) {
    return product.variants.find(function (v) {
      return product.options.every(function (name, idx) { return selected[name] === v.options[idx]; });
    }) || null;
  }

  function isCombinationAvailable(product, selected, optName, value) {
    const trial = Object.assign({}, selected, { [optName]: value });
    return product.variants.some(function (v) {
      return v.available && product.options.every(function (name, idx) { return trial[name] === v.options[idx]; });
    });
  }


  /* ── Build modal options DOM ── */
  function buildModalOptions(optionsWrap, product, modalState, onSelect) {
    const frag = document.createDocumentFragment();
    product.optionsWithValues.forEach(function (opt) {
      const group = document.createElement('div');
      group.className = 'par-opt-group';
      const label = document.createElement('div');
      label.className = 'par-opt-label';
      label.textContent = opt.name;
      group.appendChild(label);

      const asCards = isWeightOption(opt.values);
      const grid = document.createElement('div');
      grid.className = asCards ? 'par-opt-cards' : 'par-opt-pills';

      opt.values.forEach(function (value) {
        const isSelected  = modalState.selected[opt.name] === value;
        const isAvailable = isCombinationAvailable(product, modalState.selected, opt.name, value);
        const trial = Object.assign({}, modalState.selected, { [opt.name]: value });
        const prev  = findVariant(product, trial) ||
          product.variants.find(function (v) { return v.options[product.options.indexOf(opt.name)] === value; });

        if (asCards) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'par-opt-card' + (isSelected ? ' is-selected' : '') + (!isAvailable ? ' is-unavailable' : '');
          btn.disabled = !isAvailable;
          const nm = document.createElement('div'); nm.className = 'par-opt-card__name'; nm.textContent = value; btn.appendChild(nm);
          if (prev) {
            const pr = document.createElement('div'); pr.className = 'par-opt-card__price'; pr.textContent = prev.price_formatted; btn.appendChild(pr);
            if (prev.compare_at_price > prev.price) {
              const pct = Math.round((prev.compare_at_price - prev.price) / prev.compare_at_price * 100);
              const bw = document.createElement('div'); bw.className = 'par-opt-card__badge'; bw.textContent = pct + '% Off'; btn.appendChild(bw);
            }
          }
          btn.addEventListener('click', function () { if (!isAvailable) return; modalState.selected[opt.name] = value; onSelect(); });
          grid.appendChild(btn);
        } else {
          const pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'par-opt-pill' + (isSelected ? ' is-selected' : '') + (!isAvailable ? ' is-unavailable' : '');
          pill.disabled = !isAvailable;
          pill.textContent = value;
          pill.addEventListener('click', function () { if (!isAvailable) return; modalState.selected[opt.name] = value; onSelect(); });
          grid.appendChild(pill);
        }
      });
      group.appendChild(grid);
      frag.appendChild(group);
    });
    optionsWrap.replaceChildren(frag);
  }


  /* ══════════════════════════════════════════════════════════
     SECTION INIT
  ══════════════════════════════════════════════════════════ */
  function initSection(sectionEl) {
    if (sectionEl.dataset.parInit === 'true') return;
    sectionEl.dataset.parInit = 'true';

    const sid       = sectionEl.dataset.sectionId;
    const productId = sectionEl.dataset.productId;
    const intent    = sectionEl.dataset.intent || 'related';
    const limit     = parseInt(sectionEl.dataset.limit || '8', 10);
    const recUrl    = sectionEl.dataset.recUrl;
    const track     = sectionEl.querySelector('#par-track-'   + sid);
    const swiperEl  = sectionEl.querySelector('#par-swiper-'  + sid);
    const toastEl   = sectionEl.querySelector('#par-toast-'   + sid);

    /* modal refs */
    const overlay      = sectionEl.querySelector('#par-modal-overlay-'   + sid);
    const modalClose   = sectionEl.querySelector('#par-modal-close-'     + sid);
    const modalLink    = sectionEl.querySelector('#par-modal-link-'      + sid);
    const modalImg     = sectionEl.querySelector('#par-modal-img-'       + sid);
    const modalTitleEl = sectionEl.querySelector('#par-modal-title-'     + sid);
    const modalOpts    = sectionEl.querySelector('#par-modal-options-'   + sid);
    const modalAddBtn  = sectionEl.querySelector('#par-modal-add-'       + sid);
    const modalAddLbl  = sectionEl.querySelector('#par-modal-add-label-' + sid);
    const modalAddSpn  = modalAddBtn ? modalAddBtn.querySelector('.par-modal__add-spinner') : null;
    const modalCartCt  = sectionEl.querySelector('#par-modal-cart-count-' + sid);

    let modalState = null;
    let swiperInst = null;

    /* ── Recommendations fetch ── */
    async function loadRecommendations() {
      if (!productId || !recUrl) { removeSkeleton(); return; }
      try {
        const url = recUrl + '?product_id=' + productId + '&limit=' + limit + '&intent=' + intent;
        const res = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('Recommendations API error');
        const data = await res.json();
        let products = data.products || [];

        if (products.length === 0) {
          const fallback = await fetch('/collections/all/products.json?limit=' + limit, { headers: { Accept: 'application/json' } });
          if (fallback.ok) {
            const fb = await fallback.json();
            products = (fb.products || []).filter(function (p) { return String(p.id) !== String(productId); }).slice(0, limit);
          }
        }

        removeSkeleton();

        if (products.length === 0) {
          const empty = document.createElement('div');
          empty.className = 'par-empty swiper-slide';
          empty.textContent = 'No recommendations available.';
          if (track) track.appendChild(empty);
          return;
        }

        products.forEach(function (product, i) {
          const slide = document.createElement('div');
          slide.className = 'swiper-slide par-card-slide';
          slide.style.animationDelay = (i * 40) + 'ms';
          slide.innerHTML = buildCardHTML(product);
          if (track) track.appendChild(slide);
        });

        if (typeof Swiper !== 'undefined' && swiperEl) {
          if (swiperInst) swiperInst.destroy(true, true);
          swiperInst = new Swiper(swiperEl, {
            slidesPerView: 2.15, spaceBetween: 10,
            breakpoints: {
              380:  { slidesPerView: 2.3,  spaceBetween: 10 },
              480:  { slidesPerView: 2.5,  spaceBetween: 10 },
              750:  { slidesPerView: 3.4,  spaceBetween: 12 },
              992:  { slidesPerView: 4.2,  spaceBetween: 14 },
              1200: { slidesPerView: 5,    spaceBetween: 16 }
            }
          });
        }
      } catch (err) {
        removeSkeleton();
        console.warn('[pdp-auto-related] Failed to load recommendations', err);
      }
    }

    function removeSkeleton() {
      sectionEl.querySelectorAll('.par-skeleton-slide').forEach(function (el) { el.remove(); });
    }


    /* ── Modal helpers ── */
    function refreshModal(product) {
      modalState.matchedVariant = findVariant(product, modalState.selected);
      buildModalOptions(modalOpts, product, modalState, function () { refreshModal(product); });
      const allSelected = product.options.every(function (n) { return modalState.selected[n]; });
      const variant = modalState.matchedVariant;
      const canAdd  = allSelected && variant && variant.available;
      if (modalAddBtn) modalAddBtn.disabled = !canAdd;
      const lbl = !allSelected ? 'Select options' : !variant ? 'Unavailable' : !variant.available ? 'Sold Out' : 'Add to Cart';
      if (modalAddLbl) modalAddLbl.textContent = lbl;
    }

    async function openModal(card) {
      const quickTitle = card.querySelector('.par-card__title a')?.textContent || '';
      const quickImg   = card.querySelector('img')?.src || '';
      if (modalLink)    modalLink.href = card.dataset.productUrl || '#';
      if (modalImg)     { modalImg.src = quickImg; modalImg.alt = quickTitle; }
      if (modalTitleEl) modalTitleEl.textContent = quickTitle;
      if (modalOpts)    modalOpts.innerHTML = '<div class="par-modal__loading">Loading options…</div>';
      if (modalAddBtn)  modalAddBtn.disabled = true;
      if (modalAddLbl)  modalAddLbl.textContent = 'Loading…';
      if (overlay)      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (modalClose) modalClose.focus(); }, 50);
      refreshCart(modalCartCt);
      try {
        const product = await fetchProductData(card);
        const firstAvail = product.variants.find(function (v) { return v.available; }) || product.variants[0];
        const selected = {};
        if (firstAvail) product.options.forEach(function (name, idx) { selected[name] = firstAvail.options[idx]; });
        modalState = { product: product, selected: selected, matchedVariant: firstAvail };
        if (modalLink)    modalLink.href = product.url;
        if (modalTitleEl) modalTitleEl.textContent = product.title;
        refreshModal(product);
      } catch (err) {
        console.error('[pdp-auto-related] fetchProductData failed:', err);
        if (modalOpts) modalOpts.innerHTML = '<div class="par-modal__loading">Couldn\'t load options.</div>';
      }
    }

    function closeModal() {
      if (overlay) overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      modalState = null;
    }

    if (overlay) {
      if (modalClose) modalClose.addEventListener('click', closeModal);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') closeModal();
      });
    }

    if (modalAddBtn) {
      modalAddBtn.addEventListener('click', async function () {
        if (!modalState || !modalState.matchedVariant || modalAddBtn.disabled) return;
        const variantId = modalState.matchedVariant.id;
        modalAddBtn.classList.add('is-loading');
        modalAddBtn.disabled = true;
        if (modalAddSpn) modalAddSpn.hidden = false;
        try {
          const data = await cartAdd(variantId);
          refreshCart(modalCartCt);
          showToast(toastEl, (data.items[0].title || 'Item') + ' added to cart');
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          setTimeout(function () { document.dispatchEvent(new CustomEvent('cart:open-drawer', { bubbles: true })); }, 300);
          closeModal();
        } catch (err) {
          showToast(toastEl, (err && err.description) || 'Could not add to cart', true);
        } finally {
          modalAddBtn.classList.remove('is-loading');
          modalAddBtn.disabled = false;
          if (modalAddSpn) modalAddSpn.hidden = true;
        }
      });
    }

    /* ── Delegated click/keydown on cards ── */
    sectionEl.addEventListener('click', function (e) {
      const atcBtn = e.target.closest('[data-rp-atc]');
      const varSel = e.target.closest('[data-rp-variant-selector]');
      const trigger = atcBtn || varSel;
      if (!trigger) return;
      const card = trigger.closest('[data-rp-card]');
      if (!card) return;
      e.preventDefault();
      const varCount = parseInt(card.dataset.variantCount || '1', 10);
      if (varCount > 1) { openModal(card); return; }
      if (!atcBtn) return;
      const vid       = card.dataset.variantId;
      const available = card.dataset.available === 'true';
      if (!vid || !available) {
        showToast(toastEl, 'This product is unavailable', true);
        setAtcState(atcBtn, 'error');
        setTimeout(function () { setAtcState(atcBtn, 'idle'); }, 1600);
        return;
      }
      setAtcState(atcBtn, 'loading');
      atcBtn.setAttribute('data-disabled', 'true');
      cartAdd(vid).then(function (data) {
        refreshCart(null);
        showToast(toastEl, (data.items[0].title || 'Item') + ' added to cart');
        setAtcState(atcBtn, 'success');
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        setTimeout(function () { setAtcState(atcBtn, 'idle'); document.dispatchEvent(new CustomEvent('cart:open-drawer', { bubbles: true })); }, 1500);
      }).catch(function (err) {
        showToast(toastEl, (err && err.description) || 'Could not add to cart', true);
        setAtcState(atcBtn, 'error');
        setTimeout(function () { setAtcState(atcBtn, 'idle'); }, 1800);
      }).finally(function () { atcBtn.removeAttribute('data-disabled'); });
    });

    sectionEl.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const trigger = e.target.closest('[data-rp-atc], [data-rp-variant-selector]');
      if (trigger) { e.preventDefault(); trigger.click(); }
    });

    /* ── Load after first paint ── */
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadRecommendations, { timeout: 2000 });
    } else {
      setTimeout(loadRecommendations, 300);
    }
  }

  /* ── Boot ── */
  function boot() {
    document.querySelectorAll('.par-outer').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const sec = e.target ? e.target.querySelector('.par-outer') : null;
    if (sec) { sec.dataset.parInit = 'false'; initSection(sec); }
  });

})();
